import { endpoints } from 'api/endpoints'
import { GetAllData, GetAllResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { User, UserData, UserGetAllParams } from 'interfaces/api/users.interfaces'
import { axios } from 'modules/axios'
import { defaultPagination, withoutPagination } from 'utils/pagination'

const getAll = async (params?: UserGetAllParams): GetAllResponse<User> => {
  const { data: response } = await axios.request<GetAllData<User>>({
    method: 'GET',
    url: endpoints.users.getAll(),
    params: {
      ...withoutPagination(params),
      ...defaultPagination(params),
    },
  })
  return response
}

const getSingle = async (id: number): GetOneResponse<User> => {
  const { data: response } = await axios.request<User>({
    method: 'GET',
    url: endpoints.users.getSingle(id),
  })
  return response
}

const create = async (data: UserData): GetOneResponse<User> => {
  const { data: response } = await axios.request<User>({
    method: 'POST',
    url: endpoints.users.create(),
    data,
  })
  return response
}

const update = async (id: number, data: UserData): GetOneResponse<User> => {
  const { data: response } = await axios.request<User>({
    method: 'PATCH',
    url: endpoints.users.update(id),
    data,
  })
  return response
}

const remove = async (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.users.remove(id),
  })

const resetPassword = async (id: number): Promise<void> =>
  axios.request({
    method: 'GET',
    url: endpoints.users.resetPassword(id),
  })

export const usersApi = {
  getAll,
  getSingle,
  create,
  update,
  remove,
  resetPassword,
}
